import { Injectable } from '@angular/core';
import { HttpService } from './http.service';
import {
  ShopGQL,
  ShopType,
  ShopQuery,
  UpdateShopProductsMutationVariables,
  UpdateShopProductsMutation,
  UpdateShopProductsGQL,
  UserUpdateShopQuery,
  UserUpdateShopGQL,
} from 'src/gql/generated';

import { gqlErrors } from 'src/app/utils/gql-errors';

// codegen を operations のみにしたのでスキーマの型（Shop 等）は生成されない。クエリの結果型から取り、画面側もこれを使う
export type Shop = ShopQuery['shop'];
type UserUpdateShop = UserUpdateShopQuery['userUpdateShop'];

@Injectable({
  providedIn: 'root',
})
export class ShopService {
  constructor(
    private http: HttpService,
    private shopGQL: ShopGQL,
    private userUpdateShopGQL: UserUpdateShopGQL,
    private updateShopProductsGQL: UpdateShopProductsGQL,
  ) {}

  // shop情報の取得
  public async fetchShop(shopType: ShopType, shopCode: string, success: (resp: Shop) => void, error?: any) {
    const body = { shopType, shopCode };
    const resp = await this.shopGQL.fetch({ variables: body, fetchPolicy: 'network-only' }).toPromise();
    if (gqlErrors(resp)) {
      if (this.http.hasExtensions(gqlErrors(resp))) {
        error(gqlErrors(resp)[0].extensions);
      } else {
        this.http.handleError();
      }
    } else {
      success(resp.data.shop);
    }
  }

  public async fetchUserUpdateShop(success: (resp: UserUpdateShop) => void, error?: any) {
    const resp = await this.userUpdateShopGQL.fetch({ fetchPolicy: 'network-only' }).toPromise();
    if (gqlErrors(resp)) {
      if (this.http.hasExtensions(gqlErrors(resp)) && typeof error === 'function') {
        error(gqlErrors(resp)[0].extensions);
      } else {
        this.http.handleError();
      }
    } else {
      success(resp.data.userUpdateShop);
    }
  }

  public async updateShopProducts(
    body: UpdateShopProductsMutationVariables,
    success: (resp: UpdateShopProductsMutation) => void,
    error?: any,
  ) {
    const resp = await this.updateShopProductsGQL.mutate({ variables: body, fetchPolicy: 'no-cache' }).toPromise();
    if (gqlErrors(resp)) {
      if (this.http.hasExtensions(gqlErrors(resp)) && error) {
        error(gqlErrors(resp)[0].extensions);
      } else {
        this.http.handleError();
      }
    } else {
      success(resp.data);
    }
  }
}
